import type { RentalNumberQuoteFormInput } from 'app/home/create-quote/forms/rental-number/rental-number.types';
import type { QuoteDraftSelectorState } from 'app/home/global-store/quote-draft';
import type { QuoteFormOptionsSelectorState } from 'app/home/global-store/quote-form-options';

export function rentalNumberQuoteFormSelector(store: QuoteDraftSelectorState): RentalNumberQuoteFormInput {
  const rentalNumber = store.rentalNumber();
  return { rentalNumber };
}

export function rentalNumberQuoteFormOptionsSelector(store: QuoteFormOptionsSelectorState) {
  return store['rental-number']();
}
